import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { ThemeProvider } from 'glamorous';
import WebFont from 'webfontloader';
import BaseLoadingOverlay from '../common/components/LoadingOverlay';
import { isLoading } from '../redux-modules/loading-overlay';
import theme from '../theme';

const LoadingOverlay = isLoading(BaseLoadingOverlay);

WebFont.load({
  google: {
    families: ['Material+Icons'],
  },
});

const routes = {
  account: require(`./account`).default,
  auth: require(`./auth`).default,
  events: require(`./events`).default,
  users: require(`./users`).default,
  join: require(`./join`).default,
};

class App extends React.Component {
  static propTypes = {
    store: PropTypes.object,
  };

  render() {
    return (
      <Provider store={this.props.store}>
        <BrowserRouter>
          <ThemeProvider theme={theme}>
            <div>
              <Switch>
                {Object.keys(routes).map(route => {
                  return (
                    <Route
                      key={route}
                      path={`/${route}`}
                      component={routes[route]}
                    />
                  );
                })}
                <Route
                  path="/"
                  exact
                  component={require('./_root/HomePage').default}
                />
                <Route component={require('../common/PageNotFound').default} />
              </Switch>
              <LoadingOverlay />
            </div>
          </ThemeProvider>
        </BrowserRouter>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App/index.js